<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-page @page:beforein="autoSave" @page:afterin="afterin" @page:beforeout="beforeOut">
    <template v-if="currentItem">
      <f7-navbar :title="`${currentItem.title}`" back-link="back">
        <f7-nav-right>
          <f7-link @click="deleteItemOnClick">
            <font-awesome-icon icon="trash" />
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <element-path :path="currentElementPath" />

      <f7-list style="position: absolute; top: 100px; bottom: 0px; left: 0px; right: 0px; overflow: auto; margin: 5px 0px 30px;">
        <f7-list-item :link="`/stores/${storeIdProp}/menu-drafts/${menuDraftVariationProp}/items/${itemId}/image`">
          <img
            v-if="currentItem.coverImgUrl"
            :src="ImageUrlBuilder.url64(currentItem.coverImgUrl, storeIdProp)"
            style="width: 64px; margin: 0px;"
            :srcset="`${ImageUrlBuilder.url128(currentItem.coverImgUrl, storeIdProp)} 2x, ${ImageUrlBuilder.url192(currentItem.coverImgUrl, storeIdProp)} 3x`"
            slot="media" />
          <img v-else slot="media" src="@/assets/itemDefault.jpg" alt="預設圖片" style="width: 64px;" />
        </f7-list-item>

        <f7-list-item ref="title">
          <f7-label>餐點名稱</f7-label>
          <f7-input type="text" placeholder="出現在菜單上" :value="currentItem.title" @input="updateItem($event.target.value, 'title')" @focus="onFocus('title')" clear-button />
        </f7-list-item>

        <f7-list-item ref="abbreviation">
          <f7-label>餐點簡稱</f7-label>
          <f7-input type="text" placeholder="出現在廚房螢幕上" :value="currentItem.abbreviation" @input="updateItem($event.target.value, 'abbreviation')" @focus="onFocus('abbreviation')" clear-button />
        </f7-list-item>

        <f7-list-item ref="price">
          <f7-label>餐點價錢</f7-label>
          <f7-input
            type="number"
            :value="parseFloat(currentItem.price)"
            @input="updateItem(isNaN(parseFloat($event.target.value)) ? 0 : parseFloat($event.target.value), 'price')"
            @focus="onFocus('price')" clear-button />
        </f7-list-item>

        <f7-list-item ref='description'>
          <f7-label>餐點描述</f7-label>
          <f7-input type="textarea" resizable :value="currentItem.description" @input="updateItem($event.target.value, 'description')" @focus="onFocus('description')" clear-button />
        </f7-list-item>

        <f7-list-item
          title="備註"
          checkbox
          ref="specialRequests"
          :checked="currentItem.specialRequests"
          @change="updateItem($event.target.checked, 'specialRequests')" @focus="onFocus('specialRequests')"
          ></f7-list-item>

        <f7-list-item title="站點" group-title></f7-list-item>
        <f7-list-item
          checkbox
          v-for="(workStation, key) in workStationList"
          :key="`workStation-${key}`"
          :checked="itemKitchenStationId[workStation.id] ? true : false"
          :title="workStation.id"
          @change="onWorkStationSelectChanged($event.target.checked, workStation.id, currentItem.id)">
        </f7-list-item>
      </f7-list>
    </template>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ElementPath from '@/components/ElementPath'
import * as R from 'ramda'
import { storeClient } from '@/service/apiClients'

export default {
  dependencies: ['ImageUrlBuilder'],
  data () {
    return {
      pathLength: 0,
      workStationList: []
    }
  },
  computed: {
    ...mapState('menuDraftModule', ['currentElementPath', 'currentDraft']),
    ...mapState('menuModule', ['menuVariations']),
    currentItem () { return this.currentDraft.items[this.itemId] },
    groupId () { return this.currentElementPath[1].id },
    itemId () { return this.currentElementPath[2].id },
    itemIndex () { return this.currentElementPath[2].index },
    itemKitchenStationId () { return this.currentItem.kitchenStationId ? this.currentItem.kitchenStationId : {} }
  },
  async created () {
    this.pathLength = this.currentElementPath.length
    const { data: workStationList } = await storeClient.get(`stores/${this.storeIdProp}/kitchenStations`)
    this.workStationList = workStationList
  },
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String
  },
  methods: {
    updateItem (v, prop) {
      this.setItemProperties({ itemId: this.itemId, properties: R.assoc(prop, v, {}) })
    },
    onWorkStationSelectChanged (isChecked, kitchenStationId, itemId) {
      let relates = Object.assign({}, this.currentItem.kitchenStationId)
      if (isChecked) {
        relates[kitchenStationId] = true
      } else {
        delete relates[kitchenStationId]
      }
      this.updateItem(relates, 'kitchenStationId')
    },
    ...mapActions('menuDraftModule', [
      'setCurrentElementPath',
      'setItemProperties',
      'saveDraft',
      'deleteItem'
    ]),
    deleteItemOnClick () {
      this.$f7.dialog.confirm(`確定要刪除 ${this.currentItem.title} ?`, '刪除餐點', () => {
        this.deleteItem({ groupId: this.groupId, itemId: this.itemId, index: this.itemIndex })
        this.$f7router.back()
      })
    },
    onFocus (field) {
      this.$refs[field].$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    autoSave () {
      if (this.currentDraft) {
        this.saveDraft(this.currentDraft.variation)
      }
    },
    afterin () {
      this.setCurrentElementPath(this.currentElementPath.slice(0, this.pathLength))
    },
    beforeOut () {
      this.$f7.dialog.close()
    }
  },
  components: {
    ElementPath
  }
}
</script>
